import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import Select from 'react-select';
import { Form, Control, track } from 'react-redux-form';

import ModalComponent from "../ModalComponent";
import { duckify } from "../../utils/duckify";
import { billingContacts, billingContactForm, billingFinancialSplit, schoolYears, modals } from "../../ducks";
import { buildModel } from './FinancialSplit';
import ValidationErrors from "../forms/ValidationErrors";
import ControlGroup from "../forms/ControlGroup";

import './styles/FinancialSplitModal.scss';

class FinancialSplitModal extends React.Component {
  static defaultProps = {
    allDucksReady: false,
    allPayerContacts: {},
    contactId: '',
    form: {},
    model: {},
    schoolYearId: '',
    schoolYears: [],

    saveForm: () => false,
    setYear: () => false
  };

  static propTypes = {
    allDucksReady: PropTypes.bool,
    allPayerContacts: PropTypes.object,
    contactId: PropTypes.string,
    form: PropTypes.object,
    model: PropTypes.object,
    schoolYearId: PropTypes.string,
    schoolYears: PropTypes.array,

    saveForm: PropTypes.func,
    setYear: PropTypes.func,
  };

  render() {
    const {
      allDucksReady,
      allPayerContacts,
      schoolYearId,
      schoolYears,
      model,
      saving,

      setYear,
      saveForm
    } = this.props;

    const buttons = [
      <Button
        className='btn btn-primary'
        onClick={() => saveForm(model)}
        disabled={saving}
      >
        Submit
      </Button>
    ];

    return <ModalComponent
      id='financial-split-modal'
      title='Edit Financial Splits'
      buttons={buttons}
      closeText='Cancel'
    >

      <div className='financial-split-modal-header'>
        Update the financial splits for
      </div>

      <div className='financial-split-year-select'>
        <Select
          clearable={false}
          options={
            schoolYears.ready ? schoolYears.map((year) => ({
              value: year.id,
              label: year.name
            })) : []
          }
          onChange={({value}) => setYear(value, allPayerContacts)}
          value={schoolYearId}
        />
      </div>

      {allDucksReady && <Form model='billingContactForm.model'>
        <ValidationErrors errors={model.errors} fieldNames={{base: ''}}/>

        <div className='form-horizontal'>
          <div className='financial-split-modal-contacts' data-schoolYearId={model.school_year_id}>
            {
              model.billing_payers.map((payer, i) => <div key={i}>
                <ControlGroup label={`${payer.payer_contact.first_name} ${payer.payer_contact.last_name}`} showErrors={true}>
                  <Control.text
                    model={track(".billing_payers[].percent", {id: payer.id})}
                    component={PercentInput}
                    controlProps={{step: '0.01'}}
                  />
                </ControlGroup>
              </div>)
            }
          </div>
          <div className='financial-split-modal-total'>
            <ControlGroup label='Total'>
              <PercentInput
                value={model.billing_payers.reduce((a, b) => a + Number(b.percent), 0)}
                disabled={true}
              />
            </ControlGroup>
          </div>
        </div>
      </Form>}
    </ModalComponent>;
  }

  static mapStateToProps = (state) => ({
    ...state.billingContactForm
  });

  static mapDucksToProps = () => ({
    schoolYears
  });

  static mapDispatchToProps = (dispatch, ownProps) => ({

    saveForm: (model) =>
      dispatch(
        billingContactForm.actions.save(model)
      ).then((response) => {
        dispatch(billingFinancialSplit.actions.setSplit(
          ownProps.contactId,
          ownProps.schoolYearId,
          response.id
        ));

        dispatch(modals.actions.hide());
      }).catch(() => {}),

    setYear: (schoolYearId) => {
      const {
        allPayerContacts,
        contactId
      } = ownProps;

      dispatch(billingContacts.actions.load({
          contact_id: contactId,
          school_year_id: schoolYearId,
          include_billing_payers: true
        }, `${contactId}-${schoolYearId}`)
      ).then((response) => billingContacts.actions.denormalizeObjects(response)
      ).then((result) => dispatch(
        billingContactForm.actions.load(
          buildModel(
            contactId,
            schoolYearId,
            allPayerContacts,
            result.length === 0 ? undefined : result[0]
          )
        )
      ));

      return dispatch(
        modals.actions.update({
          schoolYearId: schoolYearId
        })
      )
    }
  });
}

export const PercentInput = (props) => <div className='input-group'>
  <input
    {...props}
    value={Number(props.value)}
    className='form-control form-control-sm financial-split-modal-percent'
    type='number'
  />
  <span className='input-group-text'>%</span>
</div>;


export default duckify(
  FinancialSplitModal.mapDucksToProps,
  FinancialSplitModal.mapStateToProps,
  FinancialSplitModal.mapDispatchToProps
)(FinancialSplitModal);